// Generator-discovered file route for the Lander Templates list. Component lives
// in `src/ad/routes/templates.tsx` (Module L / MIS-872) — the entry point to the
// Puck visual editor (each row links into /templates/$id/builder).
import { createFileRoute } from '@tanstack/react-router';
import { TemplatesRouteComponent } from '@/ad/routes/templates';

export const Route = createFileRoute('/_authenticated/templates/')({
  component: TemplatesRouteComponent,
});
